import React, { Component } from 'react'
import {
    Row, Col, Button
} from 'reactstrap'
import { Icon } from 'react-icons-kit'
import { ic_insert_drive_file } from 'react-icons-kit/md/ic_insert_drive_file'
import './itemArchivo.css'

export default class ItemArchivo extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.download = this.download.bind(this)
    }

    download() {
        window.open(this.props.archivo.data().Link)
    }

    render() {
        return (
            <div>
                <Col className="File" key={this.props.archivo.id} >
                    <Row>
                        <Icon className="iconFile" onClick={this.download} title={`Click para descargar`} size={60} icon={ic_insert_drive_file} />
                    </Row>
                    <Row>
                        <a className="descriptionFile" >{this.props.archivo.data().Descripcion}</a>
                    </Row>
                    {
                        this.props.admin &&
                        <Row>
                            <Button id={this.props.archivo.id} name={this.props.archivo.data().Descripcion} onClick={this.props.eliminarArchivo} outline color="danger" size="sm">Eliminar</Button>
                        </Row>
                    }

                </Col>
            </div>
        )
    }
}